/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1CoursefinancialCoursesCourseidPlans201,
  PostApiV1CoursefinancialCoursesCourseidPlans400,
  PostApiV1CoursefinancialCoursesCourseidPlans401,
  PostApiV1CoursefinancialCoursesCourseidPlans404,
  PostApiV1CoursefinancialCoursesCourseidPlans500,
  PostApiV1CoursefinancialCoursesCourseidPlansMutationRequest,
  PostApiV1CoursefinancialCoursesCourseidPlansMutationResponse,
  PostApiV1CoursefinancialCoursesCourseidPlansPathParams,
} from "../../types/courseFinancialRegistrationController/PostApiV1CoursefinancialCoursesCourseidPlans.ts";
import { courseFinancialDetailViewModelSchema } from "../courseFinancialDetailViewModelSchema.ts";
import { courseFinancialEditorViewModelSchema } from "../courseFinancialEditorViewModelSchema.ts";

export const postApiV1CoursefinancialCoursesCourseidPlansPathParamsSchema =
  z.object({
    courseId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1CoursefinancialCoursesCourseidPlansPathParams>;

/**
 * @description (Created) Objeto criado com sucesso.
 */
export const postApiV1CoursefinancialCoursesCourseidPlans201Schema = z.lazy(
  () => courseFinancialDetailViewModelSchema,
) as unknown as ToZod<PostApiV1CoursefinancialCoursesCourseidPlans201>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1CoursefinancialCoursesCourseidPlans400Schema =
  z.any() as unknown as ToZod<PostApiV1CoursefinancialCoursesCourseidPlans400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1CoursefinancialCoursesCourseidPlans401Schema =
  z.any() as unknown as ToZod<PostApiV1CoursefinancialCoursesCourseidPlans401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1CoursefinancialCoursesCourseidPlans404Schema =
  z.any() as unknown as ToZod<PostApiV1CoursefinancialCoursesCourseidPlans404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1CoursefinancialCoursesCourseidPlans500Schema =
  z.any() as unknown as ToZod<PostApiV1CoursefinancialCoursesCourseidPlans500>;

export const postApiV1CoursefinancialCoursesCourseidPlansMutationRequestSchema =
  z.lazy(
    () => courseFinancialEditorViewModelSchema,
  ) as unknown as ToZod<PostApiV1CoursefinancialCoursesCourseidPlansMutationRequest>;

export const postApiV1CoursefinancialCoursesCourseidPlansMutationResponseSchema =
  z.lazy(
    () => postApiV1CoursefinancialCoursesCourseidPlans201Schema,
  ) as unknown as ToZod<PostApiV1CoursefinancialCoursesCourseidPlansMutationResponse>;
